import { compareQuickpicks } from './compareQuickpicks'

function listingQuantity(group) {
  const quantity = Number(group?.listing?.quantity)
  return Number.isFinite(quantity) && quantity > 0 ? quantity : 0
}

export function ticketGroupMatchesFilters(group, filterParams) {
  if (
    filterParams.selectedOfferIds?.length > 0 &&
    !filterParams.selectedOfferIds.includes(group.offer?.id)
  ) {
    return false
  }
  if (filterParams.accessible && !group.accessible) return false
  if (
    !filterParams.returnLocked &&
    group.offer?.accessCode &&
    !group.offer?.unlocked
  ) {
    return false
  }
  if (group.listing) {
    return listingQuantity(group) === Number(filterParams.quantity)
  }
  if (
    group.GA &&
    (group.availableCount < filterParams.quantity || group.availableCount === 0)
  ) {
    return false
  }
  if (!group.GA) {
    const seatedAvailableCount = Array.isArray(group.seatIds)
      ? group.seatIds.length
      : 0
    const isExclusive = group.offer?.inventoryType
      ? group.offer.inventoryType !== 'open'
      : false
    if (seatedAvailableCount === 0) return false
    if (!isExclusive && seatedAvailableCount < filterParams.quantity) {
      return false
    }
  }
  return true
}

export function applyTicketGroupFilters(ticketGroups, filterParams) {
  if (!ticketGroups || ticketGroups.length === 0) return []

  return ticketGroups
    .filter((group) => ticketGroupMatchesFilters(group, filterParams))
    .sort((a, b) => compareQuickpicks(a, b, filterParams.sort))
}
